<template>
  <div class="schedule-detail__drop-route">
    <el-row>
      <el-form :inline="true">
        <el-form-item>
          <PopupChooseTemplatePickup @addTemplate="chooseTemplatePickup"></PopupChooseTemplatePickup>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="resetFilter()">{{ $t('schedule.reset') }}</el-button>
        </el-form-item>
        <el-form-item v-show="isEditable">
          <el-button type="success" @click="generate()">{{ $t('onGeneratePickup') }}</el-button>
        </el-form-item>
        <el-form-item v-show="isEditable">
          <el-button type="warning" @click="clear()">{{ $t('common.clear') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="openStatistic()">{{ $t('common.statistic') }}</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row class="schedule-detail__count">
      <el-col :span="4" :offset="2">
        <h4>{{ $t('common.total') }}</h4>
        {{ totalCount.total }}
      </el-col>
      <el-col :span="4">
        <h4>{{ $t('common.picked') }}</h4>
        {{ totalCount.picked }}
      </el-col>
      <el-col :span="4">
        <h4>{{ $t('common.not_picked') }}</h4>
        {{ totalCount.notPicked }}
      </el-col>
      <el-col :span="4">
        <h4>{{ $t('common.can_not_pick') }}</h4>
        {{ totalCount.cantPick }}
      </el-col>
      <el-col :span="4" style="color: #ff0000;">
        <h4>
          {{ $t('common.canceled') }}
          <el-switch v-model="hideCancel"></el-switch>
        </h4>
        {{ cancelCount }}
      </el-col>
    </el-row>
    <table class="student-list">
      <tr>
        <th width="3%">#</th>
        <th width="10%">
          <input class="input" type="text" v-model="filter.name" :placeholder="$t('common.full_name')"/>
        </th>
        <th width="10%">
          <input class="input" type="text" v-model="filter.romaji" :placeholder="$t('common.romaji')"/>
        </th>
        <th width="10%">
          <input class="input" type="text" v-model="filter.furigana" :placeholder="$t('common.furigana')"/>
        </th>
        <th width="10%">
          <el-select v-model="filter.classIds" multiple collapse-tags :placeholder="$t('common.class')">
            <el-option
                v-for="classItem in masterData.class_list"
                :key="classItem.id"
                :label="classItem.name"
                :value="classItem.id">
            </el-option>
          </el-select>
        </th>
        <th width="12%">
          <el-select v-model="filter.placeIds" multiple collapse-tags :placeholder="$t('common.bus_stop')">
            <el-option
                v-for="place in masterData.place_list"
                :key="place.id"
                :label="place.name"
                :value="place.id">
            </el-option>
          </el-select>
        </th>
        <th width="9%">
          <el-select v-model="filter.times" multiple collapse-tags :placeholder="$t('common.time')">
            <el-option
                v-for="time in timeList"
                :key="time"
                :label="time"
                :value="time">
            </el-option>
          </el-select>
        </th>
        <th width="5%">
          <el-checkbox v-model="checkAll" @change="checkAllTrigger"></el-checkbox>
          <br/>
          {{ checkCount }}
        </th>
        <th width="12%">
          <el-select v-model="filter.busIds" multiple collapse-tags :placeholder="$t('common.bus')">
            <el-option :label="$t('common.please_select')" value=""></el-option>
            <el-option
                v-for="bus in masterData.bus_list"
                :key="bus.id"
                :label="bus.name"
                :value="bus.id">
            </el-option>
          </el-select>
        </th>
        <th>{{ $t('menu.sub_driver') }}</th>
      </tr>
      <tr v-for="(student, index) in sortedStudentList" class="student-list__row"
          :key="student.id"
          :class="{'cant-pick': !student.can_pick, 'drop-canceled': student.isCanceled}">
        <td>{{ index + 1 }}</td>
        <td>{{student.fullname }}</td>
        <td>{{student.romaji}}</td>
        <td>{{student.furigana }}</td>
        <td>{{student.class_entity ? student.class_entity.name : ''  }}</td>
        <td>{{ student.place ? student.place.name : ''  }}</td>
        <td>
          <vue-timepicker
              v-if="timeFlag"
              :ref="`student_${student.id}`"
              @change="changeTimeTrigger($event, student)"
              v-model="student.time"
              manual-input
              auto-scroll
              close-on-complete
              format="HH:mm"
              placeholder=" "
              :disabled="!isEditable || !student.can_pick">
          </vue-timepicker>
        </td>
        <td>
          <el-checkbox @change="checkboxTrigger($event, student)" v-model="checked[student.id]"
                       :disabled="!isEditable || !student.can_pick"></el-checkbox>
        </td>
        <td>
          <select class="input" @change="chooseBus($event.target.value, student)"
                  :disabled="!isEditable || !student.time || !student.can_pick">
            <option value="">{{ $t('common.please_select') }}</option>
            <option v-for="bus in filteredBusList[student.id]"
                    :key="bus.id" :value="bus.id"
                    :selected="parseInt(student.bus_id) === bus.id" :disabled="bus.is_disabled">
              {{ bus.name }} ({{ bus.picked_seats }}/{{ bus.available_seats }})
            </option>
          </select>
        </td>
        <td>
          <select class="input" @change="chooseSubDriver($event, student)"
                  :disabled="!isEditable || !student.time || !student.can_pick">
            <option value="">{{ $t('common.please_select') }}</option>
            <option v-for="subDriver in masterData.sub_driver_list"
                    :key="subDriver.id" :value="subDriver.id"
                    :selected="parseInt(student.sub_driver_id) === subDriver.id">
              {{ subDriver.name }}
            </option>
          </select>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import {timeSort} from '@/utils'
// import {ROUTE_DROP} from '@/config'
import PopupChooseTemplatePickup from "./PopupChooseTemplatePickup";
import {mapState} from "vuex";
import {FOLLOWDAY, ROUTE_PICKUP} from "../../config";
import VueTimepicker from 'vue2-timepicker'

export default {
  name: 'ScheduleDropRouteUpdate',
  props: ['studentList', 'date', 'masterData', 'studentScheduleList', 'dataTemplateSelectedPickup'],
  components: {
    VueTimepicker,
    PopupChooseTemplatePickup
  },
  data: function () {
    return {
      filter: {
        name: '',
        furigana: '',
        classIds: [],
        placeIds: [],
        times: [],
        romaji: '',
        dropRouteIds: [],
        busIds: []
      },
      FOLLOWDAY: FOLLOWDAY,
      colorOrder: ['red', 'blue', 'yellow', 'green'],
      checked: {},
      checkAll: false,
      localStudentList: this.studentList,
      hideCancel: false,
      cancelFilteredStudentList: [],
      cancelCount: 0,
      timeout: null,
      dataTemplateSelectedStudent: null,
      timeFlag: true,
      isGenerate : false
    }
  },
  methods: {
    chooseTemplatePickup(e) {
      this.dataTemplateSelectedStudent = Object.assign({}, e)
      let data =  {}
      e.selectList.forEach(item=>{
        let obj = {
          id: item.student_id,
          bus_id: item ? item.bus_id : "",
          time:  item.time.substring(0,5) || "",
          sub_driver_id: item.sub_driver_id || ""
        }
        data['student_'+item.student_id] = Object.assign({}, obj)
      })
      this.dataTemplateSelectedStudent.dataStudent = {}
      if(e.type_template === FOLLOWDAY){
        this.dataTemplateSelectedStudent.dataStudent[e.date] = Object.assign({}, data)
      }else{
        let daylist = this.getRangerDate(new Date(e.date_start),new Date(e.date_end));
        daylist.forEach(item=>{
          this.dataTemplateSelectedStudent.dataStudent[item] = Object.assign({}, data)
        })
      }
      this.dataTemplateSelectedStudent.checkLoadTemplate = true
      this.$store.commit('schedule/updateStudentTemplatePickup', {
        data: this.dataTemplateSelectedStudent
      })
    },
    getRangerDate(start, end) {
      let arr=[]
      for(let dt= new Date(start); dt<=end; dt.setDate(dt.getDate()+1)){
        arr.push(this.$moment(new Date(dt)).format('YYYY-MM-DD'));
      }
      return arr;
    },
    chooseBus(busId, student) {
      this.$store.commit('schedule/updatePickupRouteForStudentUpdate', {
        student,
        busId: busId,
        date: this.date,
        checked: this.checked,
        availableIds: this.getAvailableIds()
      })
    },

    changeTimeTrigger(time, student) {
      this.$store.commit('schedule/updatePickupRouteTimeForStudent', {
        student,
        time: time.displayTime,
        date: this.date,
        checked: this.checked,
        availableIds: this.getAvailableIds()
      })
    },

    getAvailableIds: function () {
      let availableIds = []

      this.sortedStudentList.forEach((item) => {
        availableIds.push(item.id)
      })

      return availableIds
    },
    resetFilter: function () {
      this.filter = {
        name: '',
        furigana: '',
        classIds: [],
        placeIds: [],
        times: [],
        romaji: '',
        dropRouteIds: [],
        busIds: []
      }
    },
    canEdit: function () {
      let currentDate = this.$moment().format('YYYY-MM-DD')
      return this.date >= currentDate
    },
    generate: function () {
      this.$emit('onGeneratePickup', true)
      this.isGenerate = true
    },
    clear: function () {
      let needConfirm = false

      if(this.localStudentList){
        this.localStudentList.forEach((studentItem) => {
          if (studentItem.bus_id) {
            needConfirm = true
          }
        })
      }


      if (needConfirm) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.confirm'),
          message: this.$t('common.schedule_clear_confirm'),
          callback: () => {
            this.$store.commit('schedule/clearPickupRoute', {date: this.date})
          }
        })
      } else {
        this.$store.commit('schedule/clearPickupRoute', {date: this.date})
      }
    },
    chooseSubDriver(event, student) {
      this.$store.commit('schedule/updateSubDriverForPickupRouteUpdate', {
        student,
        subDriverId: event.target.value,
        date: this.date
      })
    },

    colorSort(before, after) {
      let beforeColor = before.pickup_route ? before.pickup_route.color.toLowerCase() : null
      let afterColor = after.pickup_route ? after.pickup_route.color.toLowerCase() : null
      let beforeIndex = this.colorOrder.indexOf(beforeColor)
      let afterIndex = this.colorOrder.indexOf(afterColor)

      if (beforeIndex === -1) {
        return 1
      }

      if (afterIndex === -1) {
        return -1
      }

      return beforeIndex < afterIndex ? -1 : beforeIndex > afterIndex ? 1 : 0
    },
    timeSort(before, after) {
      if (String(before.time).indexOf(':') === -1) {
        return -1
      }

      if (String(after.time).indexOf(':') === -1) {
        return 1
      }

      let beforeTime = before.time.split(':')
      let afterTime = after.time.split(':')
      let beforeHour = parseInt(beforeTime[0])
      let beforeMinute = parseInt(beforeTime[1])
      let afterHour = parseInt(afterTime[0])
      let afterMinute = parseInt(afterTime[1])

      if (beforeHour < afterHour) {
        return -1
      }

      if (beforeHour > afterHour) {
        return 1
      }

      if (beforeMinute < afterMinute) {
        return -1
      }

      if (beforeMinute > afterMinute) {
        return 1
      }

      return 0
    },
    classSort(before, after) {
      let beforeName = before.class_entity ? String(before.class_entity.name) : ''
      let afterName = after.class_entity ? String(after.class_entity.name) : ''
      let beforeLevel = beforeName[0]
      let beforeClass = parseInt(this.toASCII(beforeName.substring(1)))
      let afterLevel = afterName[0]
      let afterClass = parseInt(this.toASCII(afterName.substring(1)))

      if (beforeLevel === '中' && afterLevel === '小') {
        return 1
      }

      if (beforeLevel === '小' && afterLevel === '中') {
        return -1
      }

      if (beforeClass < afterClass) {
        return -1
      }

      if (beforeClass > afterClass) {
        return 1
      }

      return 0
    },
    placeSort(before, after) {
      let beforeRouteId = before.pickup_route_id ? before.pickup_route_id.id : null
      let afterRouteId = after.pickup_route_id ? after.pickup_route_id.id : null

      if (beforeRouteId === -1) {
        return 1
      }

      if (afterRouteId === -1) {
        return -1
      }

      if (beforeRouteId === afterRouteId) {
        if (typeof this.placeOrder[beforeRouteId] !== 'undefined') {
          let placeOrder = this.placeOrder[beforeRouteId]

          let beforeId = before.place ? before.place.id : null
          let afterId = after.place ? after.place.id : null
          let beforeIndex = placeOrder.indexOf(beforeId)
          let afterIndex = placeOrder.indexOf(afterId)

          if (beforeIndex === -1) {
            return 1
          }

          if (afterIndex === -1) {
            return -1
          }

          if (beforeIndex < afterIndex) {
            return -1
          }

          if (beforeIndex > afterIndex) {
            return 1
          }
        }
      }

      return 0
    },
    toASCII(chars) {
      let ascii = ''

      for (let i = 0, l = chars.length; i < l; i++) {
        let c = chars[i].charCodeAt(0)
        if (c >= 0xFF00 && c <= 0xFFEF) {
          c = 0xFF & (c + 0x20)
        }

        ascii += String.fromCharCode(c)
      }

      return ascii
    },
    checkboxTrigger(value, student) {
      this.checked[student.id] = value
      this.checked = Object.assign({}, this.checked)
    },
    checkAllTrigger(value) {
      if (!value) {
        this.localStudentList.forEach((studentItem) => {
          this.checked[studentItem.id] = false
        })
      } else {
        let checkedIds = []
        let times = []

        for (let id in this.checked) {
          if (this.checked[id]) {
            checkedIds.push(parseInt(id))
          }
        }

        if (checkedIds.length) {
          this.localStudentList.forEach((student) => {
            if (checkedIds.indexOf(student.id) !== -1 && times.indexOf(student.time) === -1) {
              times.push(student.time)
            }
          })
        }

        let callback

        if (times.length) {
          callback = (student) => {
            if (times.indexOf(student.time) !== -1) {
              this.checked[student.id] = true
            }
          }
        } else {
          callback = (student) => {
            if (student.bus_id) {
              this.checked[student.id] = true
            }
          }
        }

        this.localStudentList.forEach((student) => {
          if (student.can_pick) {
            callback(student)
          }
        })
      }

      this.checked = Object.assign({}, this.checked)
      this.localStudentList = [].concat(this.localStudentList)
    },
    openStatistic: function () {
      this.$emit('openStatistic', {
        studentList: this.studentList,
        routeType: ROUTE_PICKUP
      })
    },
    handleCancelFilter: function () {
      this.cancelCount = 0
      this.cancelFilteredStudentList = this.filteredStudentList.filter((item) => {
        if (item.isCanceled) {
          this.cancelCount++
        }

        return !this.hideCancel || !item.isCanceled
      })
    }
  },
  computed: {
    filteredStudentList: function () {
      let filteredStudentList = []
      let studentScheduleList = []
      this.studentScheduleList.forEach((studentScheduleItem) => {
        studentScheduleList[studentScheduleItem.id] = studentScheduleItem
      })
      this.localStudentList.forEach((student) => {
        let filteredStudent = Object.assign({}, student)

        if (!filteredStudent.bus_id) {
          filteredStudent.bus_id = ""
        }

        if (this.filter.name && filteredStudent.fullname.toLowerCase().indexOf(this.filter.name.toLowerCase()) === -1
            || this.filter.romaji && filteredStudent.romaji.toLowerCase().indexOf(this.filter.romaji.toLowerCase()) === -1
            || this.filter.furigana && filteredStudent.furigana.toLowerCase().indexOf(this.filter.furigana.toLowerCase()) === -1
            || (this.filter.classIds.length && (!filteredStudent.class_entity || this.filter.classIds.indexOf(filteredStudent.class_entity.id) === -1))
            || (this.filter.placeIds.length && (!filteredStudent.place || this.filter.placeIds.indexOf(filteredStudent.place.id) === -1))
            || (this.filter.times.length && this.filter.times.indexOf(filteredStudent.time) === -1)
            || (this.filter.dropRouteIds.length
                && (!filteredStudent.drop_route_info || this.filter.dropRouteIds.indexOf(filteredStudent.pickup_route_id) === -1))
            || (this.filter.busIds.length && this.filter.busIds.indexOf(filteredStudent.bus_id) === -1)) {
          return
        }

        if (typeof studentScheduleList[filteredStudent.id] !== 'undefined'
            && !studentScheduleList[filteredStudent.id].pickup) {
          filteredStudent.isCanceled = true
        }

        filteredStudentList.push(filteredStudent)
      })
      return filteredStudentList
    },
    sortedStudentList: function () {
      let sortedStudentList = [].concat(this.cancelFilteredStudentList)
      if (this.placeOrder !== null) {
        sortedStudentList.sort((before, after) => {
          if (before.can_pick === after.can_pick) {
            let colorSort = this.colorSort(before, after)

            if (colorSort !== 0) {
              return colorSort
            }

            let timeSort = this.timeSort(before, after)

            if (timeSort !== 0) {
              return timeSort
            }

            let classSort = this.classSort(before, after)

            if (classSort !== 0) {
              return classSort
            }

            let placeSort = this.placeSort(before, after)

            if (placeSort !== 0) {
              return placeSort
            }

            return 0
          } else {
            return !before.can_pick ? 1 : -1
          }
        })
      }
      return sortedStudentList
    },
    placeOrder: function () {
      if (typeof this.masterData.pickup_route_list !== 'undefined') {
        let routePlaceOrder = {}

        this.masterData.pickup_route_list.forEach((dropRoute) => {
          let placeOrder = [];

          dropRoute.place_list.forEach((place) => {
            placeOrder.push(place.id)
          })

          routePlaceOrder[dropRoute.id] = placeOrder
        })

        return routePlaceOrder
      }

      return null
    },
    busStatus: function () {
      let busStatus = {}
      this.filteredStudentList.forEach((student) => {
        if (student.bus_id && !student.isCanceled) {
          let bus = this.masterData.bus_list.find((busItem) => {
            return busItem.id === student.bus_id
          })

          if (typeof bus !== 'undefined') {
            if (typeof busStatus[student.time] === 'undefined') {
              busStatus[student.time] = {}
            }

            if (typeof busStatus[student.time][student.bus_id] === 'undefined') {
              busStatus[student.time][student.bus_id] = {
                availableSeats: bus.available_seats,
                pickedSeats: 0
              }
            }

            busStatus[student.time][student.bus_id].pickedSeats++
          }
        }
      })

      return busStatus
    },
    filteredBusList: function () {
      let filteredBusList = {}

      if (typeof this.masterData.bus_list === 'undefined') {
        return filteredBusList
      }

      let checked = []
      let currentBusSeats = {}

      for (let studentId in this.checked) {
        if (this.checked[studentId]) {
          checked.push(parseInt(studentId))
        }
      }

      this.localStudentList.forEach((student) => {
        if(student){
          if (checked.indexOf(student.id) !== -1 && student.bus_id) {
            if (typeof currentBusSeats[student.bus_id] === 'undefined') {
              currentBusSeats[student.bus_id] = 1
            } else {
              currentBusSeats[student.bus_id]++
            }
          }
        }
      })

      this.localStudentList.forEach((student) => {
        if(student){
          let busList = [].concat(this.masterData.bus_list)
          let newBusList = []
          let timeStatus = this.busStatus[student.time]
          busList.forEach((bus) => {
            let newBus = Object.assign({}, bus)
            newBus.picked_seats = 0

            let busItem = timeStatus ? timeStatus[newBus.id] : null

            if (!busItem) {
              busItem = {
                pickedSeats: 0,
                availableSeats: bus.available_seats
              }
            }

            newBus.picked_seats = busItem.pickedSeats

            if (busItem.pickedSeats >= busItem.availableSeats) {
              newBus.is_disabled = true
            }

            let currentSeats = currentBusSeats[bus.id] || 0

            if (this.checked[student.id]) {
              if (busItem.pickedSeats + (checked.length - currentSeats) > busItem.availableSeats) {
                newBus.is_disabled = true
              }
            }
            newBusList.push(newBus)
          })
          filteredBusList[student.id] = [].concat(newBusList)
        }
      })

      return filteredBusList
    },
    timeList: function () {
      let timeList = []
      this.localStudentList.forEach((student) => {
        if(student){
          if (student.time && timeList.indexOf(student.time) === -1) {
            timeList.push(student.time)
          }
        }
      })

      return timeList.sort((before, after) => timeSort(before, after))
    },
    isEditable: function () {
      return this.date >= this.$moment().format('YYYY-MM-DD')
    },
    totalCount: function () {
      let total = 0
      let picked = 0
      let notPicked = 0
      let cantPick = 0
      let canceled = 0

      let cancelStudentIds = []
      this.studentScheduleList.forEach((studentScheduleItem) => {
        if (!studentScheduleItem.pickup) {
          cancelStudentIds.push(studentScheduleItem.student_id)
        }
      })
      this.sortedStudentList.forEach((studentItem) => {
        // if (cancelStudentIds.indexOf(studentItem.student_id) !== -1) {
        //   console.log(1)
        //   canceled++
        // } else
        if (!studentItem.can_pick) {
          cantPick++
        } else if (studentItem.bus_id) {
          picked++
        } else {
          notPicked++
        }

        total++
      })
      return {
        total,
        picked,
        notPicked,
        cantPick,
        canceled
      }
    },
    checkCount: function () {
      let count = 0
      let availableIds = this.getAvailableIds()

      Object.keys(this.checked).forEach((studentId) => {
        studentId = parseInt(studentId)

        if (this.checked[studentId] && availableIds.indexOf(studentId) !== -1) {
          count++
        }
      })

      return count
    },
    ...mapState('schedule', ['studentTemplate', 'pickupStudentTemplate'])
  },
  watch: {
    studentList: {
      deep: true,
      handler: function () {
        this.localStudentList = [].concat(this.studentList)
        this.timeFlag = false

        this.$nextTick(() => {
          this.timeFlag = true
        })
      }
    },
    filter: {
      deep: true,
      handler: function () {
        this.checked = {}
      }
    },
    filteredStudentList: {
      deep: true,
      handler: function () {
        this.handleCancelFilter()
      }
    },
    hideCancel: function () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.handleCancelFilter()
      }, 500)
    }
  }
}
</script>
<style lang="scss">
</style>
